import React from "react";
import Box from "@amzn/meridian/box";
import Tag from "@amzn/meridian/tag";
 
const FilterTags = ({ states, onRemove }) => {
    return (
        <Box>
            <div className="filter-tag">
                {states.map(state => (
                    <Tag key={state}
                         onClose={() => onRemove(state)}
                         type="theme">
                        {state}
                    </Tag>
                ))}
            </div>
        </Box>
    );
};
 
export default FilterTags;


// WEBPACK FOOTER //
// ./src/components/associate/FilterTags.js